import {
  getHeaderStyleBasedOnProduct,
  getPriceModeColorCode,
} from "@components/common/Header/utils";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { getRequestType } from "@scenes/requests/utils/utils";
import { DefaultTheme } from "styled-components/native";

interface OptionsParams {
  mRoute: any;
  theme: DefaultTheme;
  userInfo: any;
  t: any;
}

export const getRequestModifyScreenOptions = ({
  mRoute,
  theme,
  userInfo,
  t,
}: OptionsParams) => {
  const params = mRoute?.params;

  if (!params) {
    return {
      headerShown: true,
      title: t("requestHistoryDetail.title.modifyRequest.text"),
    };
  }

  const { stockItemRequest = {}, productType = {}, externalPriceMode } = params;

  const isPurchasingAgent =
    stockItemRequest?.bmh_request_type === "purchasing_agent";
  const requestTypeText = isPurchasingAgent
    ? ""
    : getRequestType(stockItemRequest?.request_type);

  const title = `${t(
    "requestHistoryDetail.title.modify.text"
  )} ${requestTypeText} ${t("requestHistoryDetail.title.request.text")}`;

  const { background } = getHeaderStyleBasedOnProduct(productType.productType);

  return {
    ...(!theme.isDesktop ? { headerShown: true } : {}),
    headerTitle: title,
    title: title,
    headerTintColor: theme[`${productType.theme}-05`],
    headerStyle: {
      borderBottomColor: !userInfo.userCanSetMarkupInOrangeMode()
        ? theme[getPriceModeColorCode(externalPriceMode)]
        : theme["core-04"],
      borderBottomWidth:
        userInfo.userCanSetMarkupInOrangeMode() ||
        externalPriceMode === PriceModes.WHITE ||
        userInfo.user.price_mode === PriceModes.WHITE
          ? 1
          : 4,
      backgroundColor: background
        ? theme[background as keyof DefaultTheme]
        : theme["core-03"],
    },
  };
};
